import React from 'react';

import css from './FundingAccount.module.scss';

export default function CreditMessage() {
  return (
    <div className={css.creditMessageContainer}>
      <img src="../../static/learn-more-icon.svg" />
      <p>
        You can set up alternate forms of payment, such as debit card, for your
        monthly plan later in app.
      </p>
    </div>
  );
}
